import gql from 'graphql-tag';
import manualMailFragment from '../manualMail';

export default gql`
  fragment manualMailMailMessageFragment on ManualMailMailMessage {
    id
    updatedAt
    createdAt
    manualMail {
      ...manualMailFragment
    }
  }
  ${manualMailFragment}
`;
